module.exports = __webpack_public_path__ + "img/wide.83bf5b2e.jpg";